import { DeleteOutlined, EditOutlined, EnvironmentOutlined, FilePdfOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Form, Modal, Popconfirm, Row, Select, Space, Spin, Tooltip } from "antd";
import HTTPService from "../../../utils/makerequest";
import { IPageData, IPageProps } from "../../../interfaces/page-data";
import { useEffect, useRef, useState } from "react";
import { Toast } from 'primereact/toast';
import "../CompanyManagement/CustomerManagement.css";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { useTranslation } from 'react-i18next'; // Ekleyin
import i18n from "../../../i18n";
import { ILocationData } from "../../../interfaces/ILocationData";
import { IPrinterData } from "../../../interfaces/IPrinterData";
import { ITemplatesName } from "../../../interfaces/ITemplateName";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";

export interface ILocation {
  count?: number;
  data?: ILocationData[];
}

const LocationManagement: React.FunctionComponent<IPageProps> = (props) => {
  const toast = useRef<any>(null);
  const { onSetPage } = props;
  const { t } = useTranslation();
  const loader = new StateLoader();
  const [locationData, setLocationData] = useState<ILocation>({});
  const [templateData, setTemplateData] = useState<ITemplatesName[]>();
  const [printerData, setPrinterData] = useState<IPrinterData[]>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleExport, setIsModalVisibleExport] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const userInfo: IAuthentication = loader.loadAuthState();
  const [isLoading, setIsLoading] = useState(false);
  const dataGridRef = useRef<any>(null);

  const pageData: IPageData = {
    title: t('locationManagement'),
    loaded: true
  };

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, [i18n.language]);



  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      isSorting: true,
      width: 200,
      placeHolder: t('Company Name'),
    }] : []),
    { title: t('campus'), isSorting: true, key: 'campusName', placeHolder: t('campus'), align: 'center', headerAlign: 'center' },
    { title: t('location'), isSorting: true, key: 'locationName', placeHolder: t('location'), align: 'center', headerAlign: 'center' },
    { title: t('location_count'), isSorting: true, hideColumnMenu: true, key: 'locationCount', placeHolder: t('location_count'), align: 'center', headerAlign: 'center' },
    { title: t('locationNumber'), isSorting: true, key: 'barcode', placeHolder: t('barcode'), align: 'center', headerAlign: 'center' },
    {
      title: t('operations'),
      key: 'operations',
      placeHolder: t('operations'),
      align: 'center',
      headerAlign: 'center',
      isSorting: false,
      hideColumnMenu: true,
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginTop: 10, marginLeft: 75 }}>
          <Space size={10}>
            <Popconfirm
              title={<div>{t('are_you_sure_location')} <br /></div>}
              onConfirm={() => DeleteLocation(record.locationId)}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <Tooltip title={t('delete')}>
                <Button
                  size='small'
                  icon={<DeleteOutlined />}
                  onClick={(e) => { e.stopPropagation(); }}
                  style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
                >
                </Button>
              </Tooltip>

            </Popconfirm>
            <Tooltip title={t('update')}>
              <Button
                size='small'
                icon={<EditOutlined />}
                onClick={() => window.location.replace('/admin/update-location/' + record.locationId)}
                style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
              >
              </Button>
            </Tooltip>
          </Space>
        </div>
      ),
    }
  ];

  const AllTemplateName = (values) => {
    let companyIdToUse = values;
    HTTPService.GET(`/Template/allTemplateName?companyId=${companyIdToUse}`)
      .then((response) => {
        if (!response.data) {
          return;
        }
        let tmp: ITemplatesName[] = response.data;
        tmp.map((elem, index) => {
          elem['key'] = index;
        });
        setTemplateData(tmp);
      })
      .catch((error) => {
        console.error('Şablon çekme hatası:', error);
      });
  };


  const AllPrinterName = (values) => {
    let companyIdToUse = values;
    HTTPService.GET(`/Printer/allPrinterName?companyId=${companyIdToUse}`)
      .then((response) => {
        if (!response.data) {
          return;
        }
        let tmp: IPrinterData[] = response.data;
        tmp.map((elem, index) => {
          elem['key'] = index;
        });
        setPrinterData(tmp);
      })
      .catch((error) => {
        console.error('Cihaz çekme hatası:', error);
      });
  };

  const LocationFilter = (e?) => {
    const filters = e?.filters;
    const body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      pageSize: e?.pageSize,
      page: e?.page,
      ...filters
    };

    HTTPService.POST(`/Location/filters`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setLocationData(response.data);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
      const tmp: ILocation = response.data;
      tmp.data?.map((elem, index) => {
        elem['key'] = index;
      });
      setLocationData(tmp);
    });
  };

  const DeleteLocation = (Id) => {
    HTTPService.DELETE(`/Location/deleteLocation?Id=${Id}`).then(
      (response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
          dataGridRef.current.GetAllData()
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      }
    );
  };

  const handleCancelExport = () => {
    setIsModalVisibleExport(false);
  }

  const showModal = () => {
    if (selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('anyLocation'),
        life: 3000
      });
      return;
    }

    const distinctCompanyIds = Array.from(new Set(selectedRows.map((item: any) => item.companyId)));

    if (distinctCompanyIds.length > 1) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('sameCompany'),
        life: 3000
      });
      return;
    }

    setIsModalVisible(true);
    AllTemplateName(distinctCompanyIds[0]);
    AllPrinterName(distinctCompanyIds[0]);
  };


  const PrintData = (values) => {
    setIsLoading(true);

    // Seçili satırların verilerinden direkt companyId ve barcode al
    const printLocationBarcode = selectedRows.map(item => item.barcode);
    const companyId = selectedRows[0]?.companyId; // İlk seçili satırdan companyId'yi al

    const body = {
      printerId: values.selectPrinter,
      companyId: companyId, // Direkt selectedRows'dan alınan companyId'yi kullan
      templateId: values.selectTemplate,
      printsBarcode: printLocationBarcode
    };

    HTTPService.POST(`/Inventory/PrintInventory`, body)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          window.location.reload();
        } else {
          // ...existing error handling...
        }
      })
      .finally(() => {
        setIsLoading(false);
        setIsModalVisible(false);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  }

  const showModalExport = () => {
    if (selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('anyLocation'),
        life: 3000
      });
      return;
    }

    const distinctCompanyIds = Array.from(new Set(selectedRows.map(item => item.companyId)));

    if (distinctCompanyIds.length > 1) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('sameCompany'),
        life: 3000
      });
      return;
    }

    setIsModalVisibleExport(true);
    AllTemplateName(distinctCompanyIds[0]);
  };


  const PDFPriview = async (values) => {
    setIsLoading(true);

    try {
      const printLocationBarcode = selectedRows.map(item => item.barcode);

      const body = {
        templateId: values.selectTemplate,
        barcode: printLocationBarcode
      };

      HTTPService.POSTblob(`/Inventory/pdfpreview`, body)
        .then((response) => {
          if (response.status === 200) {
            toast.current?.show({
              severity: 'success',
              summary: t('successful'),
              detail: t('pdfSuccess'),
              life: 3000
            });
          } else if (response.status === 452) {
            toast.current?.show({
              severity: 'error',
              summary: t('mistake'),
              detail: t('licenceExpiredDate'),
              life: 3000
            });
          } else if (response.status === 453) {
            toast.current?.show({
              severity: 'error',
              summary: t('mistake'),
              detail: t('licenceNotfound'),
              life: 3000
            });
          } else {
            toast.current?.show({
              severity: 'error',
              summary: t('mistake'),
              detail: t(response.data),
              life: 3000
            });
          }
        })
        .catch((err) => {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('error'),
            life: 3000
          });
        });
    } catch (error) {
      console.error('Error in PDF preview:', error);
    } finally {
      setIsLoading(false);
      setIsModalVisibleExport(false);
    }
  };

  const handleRowSelection = (selectedRowsData: any[]) => {
    setSelectedRows(selectedRowsData);

  };


  return (
    <>
      <Toast ref={toast} />
      <Row gutter={8} style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>

          <Button
            type='primary'
            shape='round'
            size='middle'
            onClick={showModal}
            hidden={userInfo.role === UserRole.Personel}
            style={{
              height: 64,
              width: 'auto',
              backgroundColor: 'transparent',
              color: '#1890ff',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '10px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
            icon={<PrinterOutlined style={{ fontSize: 24 }} />}
          >
            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
              {t('print')}
            </span>
          </Button>

          <Button
            type='primary'
            shape='round'
            size='middle'
            onClick={showModalExport}
            hidden={userInfo.role === UserRole.Personel}
            style={{
              height: 64,
              width: 'auto',
              backgroundColor: 'transparent',
              color: '#1890ff',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '10px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
            icon={<FilePdfOutlined style={{ fontSize: 24 }} />}
          >
            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
              {t('PDF Export')}
            </span>
          </Button>

          <Button
            type="primary"
            shape="round"
            style={{
              height: 64,
              width: 'auto',
              backgroundColor: 'transparent',
              color: '#1890ff',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '5px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
            size="middle"
            onClick={() => window.location.replace('/admin/add-location')}
          >
            <EnvironmentOutlined style={{ fontSize: 24 }} />
            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
              {t('add_new_location')}
            </span>
          </Button>

        </Col>
      </Row>


      <Modal
        title={t('PDF Export')}
        visible={isModalVisibleExport}
        onCancel={handleCancelExport}
        width={800}
        footer={null}
      >
        <div style={{ padding: '10px' }}>
          <Spin spinning={isLoading}>
            <Form onFinish={PDFPriview}>
              <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label={t('select_template')}
                    name='selectTemplate'
                    rules={[
                      {
                        required: true,
                        message: t('please_select_template'),
                      },
                    ]}
                    style={{ marginBottom: '16px' }} // Adjusted margin
                  >
                    <Select
                      key='selectTemplateUpload'
                      style={{ width: '100%' }} // Ensure full width
                    >
                      {templateData?.map((item) => (
                        <Select.Option key={item.templateId} value={item.templateId}>
                          {item.templateName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    type='primary'
                    htmlType="submit"
                    shape='round'
                    size='middle'
                    style={{ width: 'auto', borderRadius: '5px' }}
                  >
                    {t('PDF Export')}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Spin>
        </div>
      </Modal>


      <Modal
        title={t('Template Printing')}
        visible={isModalVisible}
        onCancel={handleCancel}
        width={800}
        footer={null}
      >
        <div style={{ padding: '10px' }}>
          <Spin spinning={isLoading}>
            <Form onFinish={PrintData} >
              <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label={t('select_template')}
                    name='selectTemplate'
                    wrapperCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: t('please_select_template'),
                      },
                    ]}
                  >
                    <Select
                      key='selectTemplateUpload'
                      style={{ width: '100%', marginRight: '10px' }}
                    >
                      {templateData?.map((item) => (
                        <Select.Option key={item.templateId} value={item.templateId}>
                          {item.templateName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label={t('Select Printer')}
                    name='selectPrinter'
                    wrapperCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: t('Please select printer'),
                      },
                    ]}
                    style={{ marginLeft: 0 }}
                  >
                    <Select
                      key='selectPrinterUpload'
                      className='custom-select'
                    >
                      {printerData?.map((item) => (
                        <Select.Option key={item.printerId} value={item.printerId}>
                          {item.printerName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Button
                  type='primary'
                  htmlType="submit"
                  shape='round'
                  size='middle'
                  onClick={showModal}
                  style={{ width: userInfo?.role === UserRole.AltisAdmin ? '20%' : '100%', marginLeft: '575px', borderRadius: '5px' }}
                >
                  {t('print')}
                </Button>
              </Row>
            </Form>
          </Spin>
        </div>
      </Modal>
      <div className="row">
        <div className="col-md-12">
          <div className="table-container">
            <MUIDatagrid enableSelection={true} onSelectionChange={handleRowSelection} ref={dataGridRef} data={locationData.data} total={locationData.count} filterMode="server" columns={columns} onChange={LocationFilter} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationManagement;
